/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  JiHuaChaXunTiaoJian,
  JiHuaQuanZhongLeiXingGengXin,
  JiHuaXinZengShiTi,
  JiHuaYuSuanBianJi,
  PiLiangJiHuaYuSuanBianJi,
  PiLiangJiHuaZhuangTaiBianJi,
  ResponseApiGuangGaoJiHuaXiangQing,
  ResponseApiIPageGuangGaoJiHuaLieBiao,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoJiHuaGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name CampaignListUsingPost
   * @summary 分页查询计划列表
   * @request POST:/dsp-admin/api/campaign
   * @secure
   */
  campaignListUsingPost = (
    查询条件参数: JiHuaChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoJiHuaLieBiao, void>({
      path: `/dsp-admin/api/campaign`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name BatchUpdateCampaignBudgetUsingPut
   * @summary 批量更新广告计划预算
   * @request PUT:/dsp-admin/api/campaign/batch/budget
   * @secure
   */
  batchUpdateCampaignBudgetUsingPut = (
    batchBudgetUpdateDTO: PiLiangJiHuaYuSuanBianJi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/batch/budget`,
      method: "PUT",
      body: batchBudgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name BatchUpdateCampaignStatusUsingPut
   * @summary 批量更新广告计划状态（启用/暂停）
   * @request PUT:/dsp-admin/api/campaign/batch/status
   * @secure
   */
  batchUpdateCampaignStatusUsingPut = (
    batchStatusUpdateDTO: PiLiangJiHuaZhuangTaiBianJi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/batch/status`,
      method: "PUT",
      body: batchStatusUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name CreateCampaignUsingPost
   * @summary 创建广告计划
   * @request POST:/dsp-admin/api/campaign/create
   * @secure
   */
  createCampaignUsingPost = (
    createDTO: JiHuaXinZengShiTi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/campaign/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name GetCampaignUsingPost
   * @summary 获取广告计划详情
   * @request POST:/dsp-admin/api/campaign/{id}
   * @secure
   */
  getCampaignUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoJiHuaXiangQing, void>({
      path: `/dsp-admin/api/campaign/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name UpdateCampaignUsingPut
   * @summary 更新广告计划
   * @request PUT:/dsp-admin/api/campaign/{id}
   * @secure
   */
  updateCampaignUsingPut = (
    createDTO: JiHuaXinZengShiTi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/campaign/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name DeleteCampaignUsingDelete
   * @summary 删除广告计划
   * @request DELETE:/dsp-admin/api/campaign/{id}
   * @secure
   */
  deleteCampaignUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name UpdateCampaignBudgetUsingPut
   * @summary 更新广告计划预算
   * @request PUT:/dsp-admin/api/campaign/{id}/budget
   * @secure
   */
  updateCampaignBudgetUsingPut = (
    budgetUpdateDTO: JiHuaYuSuanBianJi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/${id}/budget`,
      method: "PUT",
      body: budgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name PauseCampaignUsingPut
   * @summary 暂停广告计划
   * @request PUT:/dsp-admin/api/campaign/{id}/pause
   * @secure
   */
  pauseCampaignUsingPut = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/${id}/pause`,
      method: "PUT",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name ResumeCampaignUsingPut
   * @summary 恢复广告计划
   * @request PUT:/dsp-admin/api/campaign/{id}/resume
   * @secure
   */
  resumeCampaignUsingPut = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/${id}/resume`,
      method: "PUT",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoJiHuaGuanLi
   * @name UpdateCampaignWeightTypeUsingPut
   * @summary 更新广告计划权重类型
   * @request PUT:/dsp-admin/api/campaign/{id}/weight-type
   * @secure
   */
  updateCampaignWeightTypeUsingPut = (
    weightTypeUpdateDTO: JiHuaQuanZhongLeiXingGengXin,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign/${id}/weight-type`,
      method: "PUT",
      body: weightTypeUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoJiHuaGuanLi();
